import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { getDate, getUser, isAdmin, isEditor } from "../utils";
import {
  getVisibleCmsTopNavItems,
  isCmsMainNavSectionActive,
} from "../utils/cmsMainNavConfig";
import { useState } from "react";
import Modal from "react-modal";
import { loadMessages, loadNotifications, loadMyProfile } from "../utils/Network";
import NavbarUserFiltersModal from "./widgets/NavbarUserFiltersModal";

export default function Navbar() {
  const location = useLocation();
  const user = getUser();
  const admin = isAdmin();
  const editor = isEditor();
  const primaryNavItems = getVisibleCmsTopNavItems(admin, editor);
  const [filter_course_value, setFilterCourseValue] = useState(null);
  const [filter_talent_value, setFilterTalentValue] = useState(null);
  const [filter_gender_value, setFilterGenderValue] = useState(null);
  const [filter_from_year_value, setFilterFromYearValue] = useState(null);
  const [filter_from_month_value, setFilterFromMonthValue] = useState(null);
  const [filter_to_year_value, setFilterToYearValue] = useState(null);
  const [filter_to_month_value, setFilterToMonthValue] = useState(null);
  const [filter_birth_country_value, setFilterBirthCountryValue] =
    useState(null);
  const [filter_birth_city_value, setFilterBirthCityValue] = useState(null);
  const [filter_living_country_value, setFilterLivingCountryValue] =
    useState(null);
  const [filter_living_city_value, setFilterLivingCityValue] = useState(null);

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [notifications, setNotifications] = useState(null);
  const [notification_count, setNotificationCount] = useState(0);
  
  const [messages, setMessages] = useState(null);
  const [message_count, setMessagesCount] = useState(0);
  const [profile, setProfile] = useState(null);

  const onValue = (value, name) => {
    // alert(name)
    switch (name) {
      case "course":
        setFilterCourseValue(value);
        break;
      case "talent":
        setFilterTalentValue(value);
        break;
      case "from_year":
        setFilterFromYearValue(value);
        break;
      case "from_month":
        setFilterFromMonthValue(value);
        break;
      case "to_year":
        setFilterToYearValue(value);
        break;
      case "to_month":
        setFilterToMonthValue(value);
        break;
      case "gender":
        setFilterGenderValue(value);
        break;
      case "country":
        setFilterBirthCountryValue(value);
        break;
      case "city":
        setFilterBirthCityValue(value);
        break;
      case "living_country":
        setFilterLivingCountryValue(value);
        break;
      case "living_city":
        setFilterLivingCityValue(value);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    let active = true;

    loadMyProfile()
      .then((data) => {
        if (active && data) setProfile(data);
      })
      .catch(() => {});

    if (admin) {
      loadNotifications()
        .then((data) => {
          if (!active) return;
          if (data && Array.isArray(data.results)) setNotifications(data.results);
          if (data && typeof data.count === "number") setNotificationCount(data.count);
        })
        .catch(() => {});

      loadMessages()
        .then((data) => {
          if (!active) return;
          if (data && Array.isArray(data.results)) setMessages(data.results);
          if (data && typeof data.count === "number") setMessagesCount(data.count);
        })
        .catch(() => {});
    }

    return () => {
      active = false;
    };
  }, []);

  const profileName = `${profile?.first_name || ""} ${profile?.last_name || ""}`.trim();
  const displayName = profileName || user?.email || "User";
  const avatarInitial = (displayName || "U").trim().charAt(0).toUpperCase();

  const closeModal = () => {
    setModalIsOpen(false);
  };

  return (
    <div>
      <header className="main-header cms-header-redesigned">
        <div className="header-container-custom">
        <a href="/cms/dashboard" className="logo cms-logo-image-wrap">
          <img
            src="/assets/images/logo_top.png"
            alt="KurdishTalent"
            className="cms-logo-img"
          />
        </a>

        <nav className="navbar navbar-static-top cms-navbar-with-primary cms-navbar-reference">
          <div className="container cms-navbar-container">
            <div className="cms-navbar-center">
              <div className="cms-navbar-pill-wrap">
                <ul
                  className="cms-navbar-primary-nav"
                  aria-label="Primary CMS navigation"
                >
                  {primaryNavItems.map((section) => (
                    <li key={section.key}>
                      <Link
                        to={section.to}
                        className={
                          isCmsMainNavSectionActive(location.pathname, section)
                            ? "is-active"
                            : ""
                        }
                      >
                        {section.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="cms-navbar-right">
              <div className="navbar-custom-menu cms-navbar-actions">
                <ul className="nav navbar-nav">
              {admin && <>
              <li className="dropdown messages-menu hide-on-small">
                <a href="#d" className="dropdown-toggle" data-toggle="dropdown">
                  <i className="fa fa-envelope-o"></i>
                  {message_count>0 && 
                  <span className="label label-success">{message_count}</span>
                  }
                </a>
                <ul className="dropdown-menu cms-navbar-dark-dropdown">
                  <li className="header">You have {message_count} messages</li>
                  <li>
                    <ul className="menu">
                      {messages?.map((message)=>(
                        <li key={"m_"+message.id}>
                        <a href={`/cms/message/${message.id}`}>
                          <div className="pull-left">
                            <img
                              src={message.user?.profile.image ? message.user?.profile.image : "/assets/cms/assets/dist/img/user2-160x160.jpg"}  
                              className="img-circle"
                              alt={message.user?.profile.first_name+" "+ message.user?.profile.last_name}
                            />
                          </div>
                          <h4>
                            {message.user?.profile.first_name+" "+ message.user?.profile.last_name}
                            <small>
                              <i className="fa fa-clock-o"></i> 5 mins
                            </small>
                          </h4>
                          <p className="kfont">{message.message}</p>
                        </a>
                      </li>
                      ))}
                      
                    </ul>
                  </li>
                  <li className="footer">
                    <a href="/cms/messages">See All Messages</a>
                  </li>
                </ul>
              </li>

              <li className="dropdown notifications-menu">
                <a href="#d" className="dropdown-toggle" data-toggle="dropdown">
                  <i className="fa fa-bell-o"></i>
                  {notification_count>0 &&
                    (<span className="label label-warning" style={{backgroundColor: "#3c8dbc"}}>{notification_count}</span>)
                  }
                </a>
                <ul className="dropdown-menu cms-navbar-dark-dropdown">
                  <li className="header">You have {notification_count} notifications</li>
                  <li>
                    <ul className="menu">
                      {notifications?.map((item) => (
                        <li key={item.key}>
                          <a href="/cms/notifications">
                            <div className="">
                              <i className="fa fa-notification"></i>{" "}
                              {item.title}
                            </div>
                            <small className="pull-right">
                              <i className="fa fa-clock-o"></i>{" "}
                              {getDate(item.created_at)}
                            </small>
                          </a>
                        </li>
                      ))}
                    </ul>
                  </li>
                  <li className="footer">
                    <a href="/cms/notifications">See All Notifications</a>
                  </li>
                </ul>
              </li>

              

              <li className="tasks-menu">
                <a
                  href="#d"
                  onClick={() => {
                    setModalIsOpen(true);
                  }}
                  className="dropdown-toggle"
                  data-toggle="dropdown"
                >
                  <i className="fa fa-search"></i>
                </a>
              </li>
              </>}
              <li className="cms-navbar-icon-link">
                <a href="/" target="_blank" rel="noopener noreferrer">
                  <i className="fa fa-globe"></i>
                  <span className="sr-only">Open public site</span>
                </a>
              </li>
              <li className="cms-navbar-icon-link">
                <Link
                  to="/cms/signout"
                  title="Sign out"
                  aria-label="Sign out"
                >
                  <i className="fa fa-sign-out"></i>
                </Link>
              </li>
              {/* <li className="dropdown user user-menu cms-navbar-user-menu" >
                <a href="#d" className="dropdown-toggle" data-toggle="dropdown">
                  <span
                    className="user-image"
                    aria-label={displayName}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "transparent",
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: "12px",
                      textTransform: "uppercase",
                      border: "1px solid rgba(255,255,255,0.35)",
                    }}
                  >
                    {avatarInitial}
                  </span>
                  <span className="hidden-xs cms-navbar-user-label">{displayName}</span>
                </a>
                <ul className="dropdown-menu" style={{backgroundColor: "#1e2a32", borderColor: "#1e2a32"}}>
                  <li className="user-footer" style={{backgroundColor: "#1e2a32", borderColor: "#1e2a32"}}>
                    <div className="pull-right">
                      <Link to="/cms/signout" className="btn btn-default btn-flat">
                        Sign out
                      </Link>
                    </div>
                  </li>
                </ul>
              </li> */}
                </ul>
              </div>
            </div>
          </div>
        </nav>
        </div>

      </header>
      <Modal
        closeTimeoutMS={500}
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        className="Modal Modal--navbar-filters"
        overlayClassName="Overlay"
      >
        <NavbarUserFiltersModal
          closeModal={closeModal}
          onValue={onValue}
          filter_course_value={filter_course_value}
          filter_talent_value={filter_talent_value}
          filter_gender_value={filter_gender_value}
          filter_from_year_value={filter_from_year_value}
          filter_from_month_value={filter_from_month_value}
          filter_to_year_value={filter_to_year_value}
          filter_to_month_value={filter_to_month_value}
          filter_birth_country_value={filter_birth_country_value}
          filter_birth_city_value={filter_birth_city_value}
          filter_living_country_value={filter_living_country_value}
          filter_living_city_value={filter_living_city_value}
        />
      </Modal>
    </div>
  );
}
